import { AUTH_HEADER } from '@/core/constants/http-headers'
import { IHttpClient } from '@/core/services/http'
import { ITokenService } from '@/core/services/tokens/token.service.interface'
import { PaymentDetailsResponse } from '../types/api-responses/payment-details-response'
import { AskForPaymentModel } from '../types/models/ask-for-payment.model'
import { PaymentDetailsModel } from '../types/models/payment-details.model'
import { AskForPaymentDto } from '../types/request-dto/ask-for-payment.dto'

export function createAskForPaymentUseCase({
  httpClient,
  tokenService,
}: {
  httpClient: IHttpClient
  tokenService: ITokenService
}) {
  return async function (input: AskForPaymentModel, update: boolean) {
    const json = inputToJson(input)
    const { token, accountType } = await tokenService.getToken()
    const authHeaders = token ? AUTH_HEADER(token) : {}
    const endpoint = update
      ? `/website/${accountType}/askForPaymentUpdateTrip`
      : `/website/${accountType}/trip/askForPayment`
    const res = await httpClient
      .version('v1')
      .addHeaders(authHeaders)
      .post<{ data: PaymentDetailsResponse }>(endpoint, json)

    return resolver(res.data.data)
  }
}

function inputToJson(input: AskForPaymentModel): AskForPaymentDto {
  return {
    payment_method: input.paymentMethod,
    trip_id: input.tripId,
    promo_code: input.promoCode,
  }
}

function resolver(res: PaymentDetailsResponse): PaymentDetailsModel {
  return {
    amountFromBank: res.amount_from_stripe ?? 0,
    amountFromPaypal: res.amount_from_paypal ?? 0,
    amountFromWallet: res.amount_from_wallet ?? 0,
    clientSecret: res.client_secret,
    customers: res.customers,
    from: res.from,
    transactionId: res.transaction_id,
  }
}
